import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import * as amplitude from "@amplitude/analytics-browser";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

amplitude.init(
  (process.env.NODE_ENV === "production"
    ? process.env.REACT_APP_AMPLITUDE
    : " asdfasdfasdfas asdfasdfasfda sdfasfas")!,
  { defaultTracking: true }
);
const identifyEvent = new amplitude.Identify();
amplitude.identify(identifyEvent);
if (window.matchMedia("(display-mode: standalone)").matches) {
  // The web app is being used from the home screen
  const identifyEvent = new amplitude.Identify();
  identifyEvent.set("displayMode", "standalone");
  amplitude.identify(identifyEvent);
  amplitude.track("Running in Standalone Mode");
} else {
  // The web app is being used from the browser
  const identifyEvent = new amplitude.Identify();
  identifyEvent.set("displayMode", "browser");
  amplitude.identify(identifyEvent);

  amplitude.track("Running in browser Mode");
}
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
